import React from 'react';
import './Settings.css';

function OnboardingChecklist({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <button className="back-button" onClick={onBack}>
                <span className="back-icon">←</span>
                <span>Back to TA Settings</span>
            </button>

            <div className="settings-component-content">
                <div className="settings-component-header">
                    <h1>✅ Onboarding Checklist</h1>
                    <p>Set up onboarding tasks and checklists</p>
                </div>

                <div className="settings-component-body">
                    <div className="settings-info-card">
                        <h3>Onboarding Features</h3>
                        <p>This section will allow you to:</p>
                        <ul>
                            <li>Create onboarding checklists</li>
                            <li>Define onboarding tasks</li>
                            <li>Set task dependencies</li>
                            <li>Track completion progress</li>
                        </ul>
                    </div>

                    <div className="settings-placeholder-message">
                        <span className="placeholder-icon">🚧</span>
                        <p>Onboarding Checklist configuration coming soon...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OnboardingChecklist;
